import * as React from 'react';
import { LinkButton } from '@cian/ui-kit';
import { useIsDesktop } from '@cian/valuation-utils-component';
import { useSelector } from 'react-redux';

import { selectPage } from '../../../../selectors/selectPage';

interface IBackButtonProps {
  onClick: () => void;
}

export const BackButton: React.FC<IBackButtonProps> = ({ onClick }) => {
  const isDesktop = useIsDesktop();
  const { referrer } = useSelector(selectPage);

  return (
    <LinkButton size="M" href={referrer} fullWidth={!isDesktop} onClick={onClick}>
      {isDesktop ? 'Понятно' : 'Хорошо'}
    </LinkButton>
  );
};
